import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import PintaPortfolio from "./components/PintaPortfolio";
import React, { useState } from "react";

function App() {
  const [showPortfolio, setShowPortfolio] = useState(false);

  const handleShowPortfolio = () => {
    setShowPortfolio(true); // Muestra el iframe de portfolio
  };

  const handleBackToHome = () => {
    setShowPortfolio(false); // Regresa al contenido principal
  };

  return (
    <div className="App">
      {!showPortfolio ? (
        <>
          <NavBar onShowPortfolio={handleShowPortfolio} />
          <Banner />
          <Projects />
          <Skills />
          <Contact />
          <Footer />
        </>
      ) : (
        <PintaPortfolio onBack={handleBackToHome} />
      )}
    </div>
  );
}

export default App;
